import checkmarkIcon from "./resources/images/checkmarkIcon.svg";
import plusIcon from "./resources/images/plusIcon.svg";

export const CHECKBOX_ICONS = [
    {
        classname: "plusIcon",
        src: plusIcon,
        key: "plusIcon",
    },
    {
        classname: "checkmarkIcon",
        src: checkmarkIcon,
        key: "checkmarkIcon",
    },
];
